<label [for]="inputId" class="visually-hidden" *ngIf="useScreenReaderLabel || screenReaderLabel">
  {{ screenReaderLabel || placeholder }}
</label>
<input
  [type]="type"
  class="form-control"
  #inputRef
  [name]="name"
  [id]="inputId"
  [formControl]="control"
  [placeholder]="placeholder"
  [value]="value"
  [pattern]="pattern"
  [attr.maxlength]="maxlength"
  [readonly]="readonly"
  [autocomplete]="autocompleteValue"
  [expandOnFocusSize]="expandOnFocusSize"
  [expandOnFocusChildClass]="expandOnFocusChildClass"
  shrdUicExpandOnFocus
/>
